(function(){
    ("use strict");

    // Global variables
    var squiz = {
        fn: {},
        vars: {},
    };

    // Functions
    squiz.fn.sampleFunction = function () {};

    const proto = squiz.fn;

    /**
     * sets a hook on the squiz variable object
     *
     * @param {string} name
     * the name of the hook
     *
     * @param {any} value
     * the value of the hook
     *
     * @return {void}
    */
    proto.setHook = function (name, value) {
        squiz.vars[name] = value;

        return;
    }

    /**
     * gets a set hook from the squiz variable object
     *
     * @param {string} name
     * the name of the hook you want to get the value of
     *
     * @param {callable} callback
     * the callback will execute and return the value of the hook
     * only if the hook is found
     *
     * @return {void}
    */
    proto.getHook = function (name, callback) {
        if (!callback) return;

        const value = squiz.vars[name];

        if (!value) return;

        callback(squiz.vars[name]);

        return;
    }

    const searchBtn = document.querySelector(".btn-search");
    const searchClose = document.querySelector(".site-search-input-close-btn");
    const searchField = document.querySelector(".site-search-input");
    const searchForm = document.querySelector(".search-form");
    const searchCloseDesktop = document.querySelector(
        ".search-component-close-btn"
    );
    const searchSuggestion = document.querySelector(".site-search-suggestion");
    const navbar = document.querySelector(".navbar");
    const flyoutMenu = document.querySelector(".flyout-menu");
    const searchTerm = document.querySelector(".search-term-suggestion");
    if (searchBtn) {
        searchBtn.addEventListener("click", () => {
            searchClose.classList.add("active");
            searchField.focus();
            navbar.classList.add("hide");
            searchSuggestion.classList.add("active");
        });
    }
    if (searchClose) {
        searchClose.addEventListener("click", () => {
            searchClose.classList.remove("active");
            navbar.classList.remove("hide");
        });
    }

    if (searchField) {
        searchCloseDesktop.addEventListener("click", (e) => {
            e.preventDefault();
            searchField.value = "";
            searchSuggestion.classList.remove("active");
            searchTerm.classList.remove("active");
            flyoutMenu.classList.remove("hide");
            navbar.classList.remove("hide");
            searchClose.classList.remove("active");
        });
        searchField.addEventListener("input", function () {
            searchSuggestion.classList.add("active");
            if (this.value.length >= 1) {
                flyoutMenu.classList.add("hide");
                searchTerm.classList.add("active");
            } else {
                searchTerm.classList.remove("active");
            }
        });
        searchField.addEventListener("keydown", function (event) {
            const key = event.key;
            if (key === "Backspace" && this.value.length <= 1) {
                flyoutMenu.classList.remove("hide");
            }
        });
    }
    document.onclick = function (e) {
        if (!e.target.classList.contains("search-component")) {
            searchSuggestion.classList.remove("active");
        }
    };

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            searchSuggestion.classList.remove("active");
            flyoutMenu.classList.remove("hide");
        }
    });
    const autoComplete = require("@tarekraafat/autocomplete.js");
    const autoCompleteJS = new autoComplete({
        data: {
            src: async () => {
                try {
                    // Fetch Data from external Source
                    const source = await fetch(
                        "https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json?show=5&alpha=0.5&sort=0&collection=ce4a1be2-7b51-43fe-a7af-73dfeb2db83a~sp-search&partial_query=article&fmt=json++"
                    );
                    const data = await source.json();
                    return data;
                } catch (error) {
                    return error;
                }
            },
            keys: ["disp"],
            cache: false,
        },
        resultsList: {
            tag: "ul",
            class: "search-suggestion-results",
            destination: "#autocompleteResults",
            position: "afterbegin",
            maxResults: 5,
            noResults: true,
            element: (list, data) => {
                if (!data.results.length) {
                    const message = document.createElement("div");
                    // Add class to the created element
                    message.setAttribute("class", "no_result");
                    // Add message text content
                    message.innerHTML = `<span>${data.query}</span>`;
                    // Append message element to the results list
                    list.prepend(message);
                }
            },
        },
        wrapper: false,
        submit: true,
        resultItem: {
            highlight: "autoComplete-highlight",
        },
        events: {
            input: {
                selection: (event) => {
                    const selection = event.detail.selection.value;
                    autoCompleteJS.input.value = selection.disp;
                    searchForm.submit();
                },
            },
        },
    });

    // Make squiz variable available to the console for debugging
    window.squiz = squiz;
    
    const hamburger = document.querySelector(".navbar-toggler");
    const btnLogin = document.querySelector(".btn-login");
    const showMenu = (e) => {
        if(document.body.classList.contains('menu-active')) {
            document.body.classList.remove("menu-active");
        }else {
            document.body.classList.add("menu-active");
        }
    }

    const showLoginMenu = (e) => {
        const attribute  = btnLogin.getAttribute("target");
        const element = document.getElementById(attribute);
        if(element.classList.contains('active')) {
            element.classList.remove("active");
        }else {
            element.classList.add("active");
        }
    }
    document.querySelectorAll("header .top-nav__list a").forEach(item => {
        item.addEventListener('click', () => {
            const attribute  = item.getAttribute("target");
            const element = document.getElementById(attribute);
            if(element.classList.contains('active')) {
                element.classList.remove("active");
            }else {
                element.classList.add("active");
            }
        })
    })
    document.querySelectorAll('.navigation-lvl2__column-title button').forEach(item => {
        item.addEventListener('click', () => {
            const activeLabel = item.parentElement;
            if(activeLabel.classList.contains('active')) {
                activeLabel.classList.remove("active");
            }else {
                activeLabel.classList.add("active");
            }
        })
    })
    
    document.querySelectorAll(".navigation-link button").forEach((item) => {
        item.addEventListener("click", () => {
            document.querySelectorAll(".nav-item").forEach((e) => {
                const parent = item.parentElement.parentElement;
                if (e !== parent) {
                    e.classList.remove("active");
                }
            });
            document.querySelectorAll(".navigation-link").forEach((e) => {
                const parent = item.parentElement;
                if (e !== parent) {
                    e.classList.remove("active");
                }
            });

            const parent = item.parentElement;

            if (parent.classList.contains("active")) {
                setTimeout(() => {
                    parent.classList.remove("active");
                    parent.parentElement.classList.remove("active");
                }, 10);
            } else {
                setTimeout(() => {
                    parent.classList.add("active");
                    parent.parentElement.classList.add("active");
                }, 10);
            }
        });
    });
    

    
    hamburger.addEventListener("click", showMenu);
    btnLogin.addEventListener("click", showLoginMenu);

}());
